var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_755_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4C10.4178 4 8.87103 4.46919 7.55544 5.34824C6.23985 6.22729 5.21447 7.47672 4.60897 8.93853C4.00347 10.4003 3.84504 12.0089 4.15372 13.5607C4.4624 15.1126 5.22433 16.538 6.34315 17.6569C7.46197 18.7757 8.88743 19.5376 10.4393 19.8463C11.9911 20.155 13.5997 19.9965 15.0615 19.391C16.5233 18.7855 17.7727 17.7602 18.6518 16.4446C19.5308 15.129 20 13.5822 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM12 18.8571C10.6438 18.8571 9.31803 18.455 8.19038 17.7015C7.06273 16.948 6.18383 15.8771 5.66483 14.6241C5.14583 13.3711 5.01003 11.9924 5.27462 10.6622C5.5392 9.33208 6.19228 8.11026 7.15127 7.15127C8.11026 6.19228 9.33209 5.5392 10.6622 5.27461C11.9924 5.01003 13.3711 5.14582 14.6241 5.66483C15.8771 6.18383 16.948 7.06272 17.7015 8.19037C18.455 9.31803 18.8571 10.6438 18.8571 12C18.8571 13.8186 18.1347 15.5628 16.8487 16.8487C15.5628 18.1347 13.8186 18.8571 12 18.8571Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.57141C11.3219 8.57141 10.659 8.77249 10.0952 9.14923C9.53135 9.52597 9.0919 10.0614 8.8324 10.6879C8.5729 11.3144 8.505 12.0038 8.63729 12.6689C8.76958 13.3339 9.09612 13.9449 9.57562 14.4243C10.0551 14.9038 10.666 15.2304 11.3311 15.3627C11.9962 15.495 12.6856 15.4271 13.312 15.1676C13.9385 14.9081 14.474 14.4686 14.8507 13.9048C15.2275 13.341 15.4286 12.6781 15.4286 12C15.4286 11.0907 15.0673 10.2186 14.4243 9.57562C13.7814 8.93263 12.9093 8.57141 12 8.57141Z",
    fill: "#161616"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioSelected);
export default __webpack_public_path__ + "static/media/Radio_selected.0041a077ee38b1a9df6106cae19d38b5.svg";
export { ForwardRef as ReactComponent };